// Import Libraries
import { isPointWithinRadius, orderByDistance } from "geolib";
// Import Utils
import { getMeters } from "../convertDistance";

// -> FIND NEARBY HOTELS BY MAP COORDINATES
const getNearbyAttractions = (attractions, location, radius) => {
  if (location === null) return;
  attractions = attractions.map((el) => {
    return {
      ...el,
      location: {
        lat: el.mapSearchOptions.filterByLocation.lat,
        lng: el.mapSearchOptions.filterByLocation.lng,
      },
    };
  });
  // Map option variable
  let locationFilteredHotels = [];

  // All filtered attraction arrays will go in here
  let allFilteredHotels = [];

  // FIRST GET RADIUS
  // Check if radius field isn't empty, if it is default to 50 miles
  let searchRadius = radius ? radius : 50;
  // Conver to meters (geolib needs meters)
  searchRadius = getMeters(searchRadius);

  // Loop through all attractions & get all coordinates that meet requirements and put in array e.g., id, {coords}
  attractions.forEach((attraction) => {
    const attractionLocation = attraction.location;

    // if attraction has no coordinates then skip attraction
    if (!attractionLocation || !attractionLocation.lat) {
      return null;
    }
    // Check that attraction is within radius of pillar pages search map coordinates
    let attractionWithinRadius = isPointWithinRadius(
      attractionLocation,
      location,
      searchRadius
    );

    if (attractionWithinRadius) {
      // Place into array as new object with lat, lng & id so we can later orderByDistance
      locationFilteredHotels.push({
        lat: attractionLocation.lat,
        lng: attractionLocation.lng,
        id: attraction._id,
      });
    }

    // if true push into an array we define at top
  });

  // orderByDistance (geolib) to get attractions in ascending order of distance (closest is first)
  const orderedLocationsByDistance = orderByDistance(
    location,
    locationFilteredHotels
  );

  // Save all attraction Ids into our allFilteredHotels array
  allFilteredHotels = orderedLocationsByDistance.map(
    (attraction) => attraction.id
  );

  return allFilteredHotels;
};

export { getNearbyAttractions };
